// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"515":"f78dfd11","589":"dcb4dee6","677":"5f5e2cff","883":"00c90c34"}[chunkId] + ".chunk.js";
};